import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1661311146605'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='15741'
    >
        <path
            d='M912 329.493333h-149.333333a5.333333 5.333333 0 0 1-5.333334-5.333333V112a5.333333 5.333333 0 0 0-5.333333-5.333333H112a5.333333 5.333333 0 0 0-5.333333 5.333333v800a5.333333 5.333333 0 0 0 5.333333 5.333333h714.666667a90.666667 90.666667 0 0 0 90.666666-90.666666V334.826667a5.333333 5.333333 0 0 0-5.333333-5.333334zM682.666667 837.333333a5.333333 5.333333 0 0 1-5.333334 5.333334H186.666667a5.333333 5.333333 0 0 1-5.333334-5.333334V186.666667a5.333333 5.333333 0 0 1 5.333334-5.333334h490.666666a5.333333 5.333333 0 0 1 5.333334 5.333334z m160-37.333333a42.666667 42.666667 0 1 1-85.013334 0V409.493333a5.333333 5.333333 0 0 1 5.333334-5.333333H837.333333a5.333333 5.333333 0 0 1 5.333334 5.333333z'
            p-id='15742'
            fill='currentColor'
        ></path>
        <path
            d='M258.186667 564.106667m5.333333 0l336.96 0q5.333333 0 5.333333 5.333333l0 64q0 5.333333-5.333333 5.333333l-336.96 0q-5.333333 0-5.333333-5.333333l0-64q0-5.333333 5.333333-5.333333Z'
            p-id='15743'
            fill='currentColor'
        ></path>
        <path
            d='M258.186667 686.453333m5.333333 0l336.96 0q5.333333 0 5.333333 5.333334l0 64q0 5.333333-5.333333 5.333333l-336.96 0q-5.333333 0-5.333333-5.333333l0-64q0-5.333333 5.333333-5.333334Z'
            p-id='15744'
            fill='currentColor'
        ></path>
        <path
            d='M343.946667 485.653333h92.8A152.853333 152.853333 0 0 0 476.106667 480a70.4 70.4 0 0 0 29.76-17.013333 87.466667 87.466667 0 0 0 21.653333-31.626667c5.333333-12.586667 7.786667-30.293333 7.786667-53.333333a157.973333 157.973333 0 0 0-5.333334-41.386667 93.92 93.92 0 0 0-16.906666-34.293333 76.853333 76.853333 0 0 0-29.546667-22.613334A117.92 117.92 0 0 0 436.746667 272h-92.8a5.333333 5.333333 0 0 0-5.333334 5.333333v202.986667a5.333333 5.333333 0 0 0 5.333334 5.333333z m60.693333-160a5.333333 5.333333 0 0 1 5.333333-5.333333H421.333333q25.706667 0 36.746667 12.533333c7.413333 8.373333 11.093333 23.84 11.093333 46.506667a100.693333 100.693333 0 0 1-4.96 37.333333 31.146667 31.146667 0 0 1-13.706666 16 68.266667 68.266667 0 0 1-29.44 4.586667h-10.666667a5.333333 5.333333 0 0 1-5.333333-5.333333z'
            p-id='15745'
            fill='currentColor'
        ></path>
    </svg>
)

export const DailyIcon = props => <Icon component={SVG} {...props} />
